<template>
  <!-- 直播资料 -->
  <div>
    <div class="detailDesText">
      <div class="title">
        <span>{{ liveInfo.liveName }}</span>
        <span class="price" v-if="liveInfo.isPurchase === 0">免费</span>
        <span class="price" v-else>
          ¥
          <span>{{ liveInfo.liveAmt }}</span>
        </span>
      </div>
      <p style="font-size: 14px" v-if="liveInfo.liveStatus === 0">
        开始时间：{{ liveInfo.liveStartTime.substring(0, 19) }}
      </p>
      <p style="font-size: 14px" v-if="liveInfo.liveStatus === 0">
        结束时间：{{ liveInfo.liveEndTime.substring(0, 19) }}
      </p>
    </div>
    <div v-if="liveInfo.isLiable" class="context">
      <div class="columns">
        <img src="../../assets/img/liveInfo.png" />
        <span class="p-title">直播信息</span>
        <img
          style="float: right; margin-top: 5px"
          @click="showInfo"
          :src="
            !infoShow
              ? require('../../assets/img/menu_down.png')
              : require('../../assets/img/menu_up.png')
          "
          alt
        />
        <div :class="{ contextShow: !infoShow }">
          <div class="live_infoItem">
            <div class="label">推流地址:</div>
            <div class="live_infoItemC">{{ liveInfo.adapter.publishUrl }}</div>
            <div style="width: 56px">
              <span
                class="y_color"
                v-clipboard:copy="liveInfo.adapter.publishUrl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >复制</span
              >
            </div>
          </div>
          <div class="live_infoItem">
            <div class="label">串流秘钥:</div>
            <div class="live_infoItemC">{{ liveInfo.adapter.pushToken }}</div>
            <div style="width: 56px">
              <span
                class="y_color"
                v-clipboard:copy="liveInfo.adapter.pushToken"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >复制</span
              >
            </div>
          </div>
          <div class="live_infoItem">
            <div class>是否开启直播：</div>
            <div class="live_infoItemC" style="height: 30px">
              <van-button
                round
                size="mini"
                color="#909399"
                :disabled="liveInfo.liveIsShelves === 1"
                v-if="liveInfo.liveStatus === 0 || liveInfo.liveStatus === 2"
                @click="handelUpdate()"
                >{{
                  liveInfo.liveIsShelves === 1 ? '该直播已下架' : '开启直播'
                }}</van-button
              >
              <van-button
                round
                size="mini"
                color="#85ce61"
                v-if="liveInfo.liveStatus === 1"
                @click="handelUpdate()"
                >关闭直播</van-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 内容概要 -->
      <div class="context">
        <div class="columns">
          <img src="../../assets/img/list1.png" />
          <span class="p-title">直播介绍</span>
          <img
            style="float: right; margin-top: 5px"
            @click="showMenu"
            :src="
              !menuShow
                ? require('../../assets/img/menu_down.png')
                : require('../../assets/img/menu_up.png')
            "
            alt
          />
        </div>

        <p
          v-if="!menuShowAll && !menuShow"
          class="p-desc"
          v-html="liveInfo.liveDetail"
          @click="imageChgange($event)"
          v-clipboard:copy="liveInfo.liveDetail"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          :class="{ contextShowAll: !menuShowAll }"
        ></p>

        <p
          v-if="menuShow || !menuShowAll"
          class="p-desc"
          v-html="liveInfo.liveDetail"
          @click="imageChgange($event)"
          v-clipboard:copy="liveInfo.liveDetail"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          :class="{ contextShow: !menuShow }"
        ></p>

        <div class="AllShadow">
          <mt-button
            type="primary"
            size="large"
            v-if="!menuShowAll && !menuShow"
            @click="showMenuAll"
            >点击展开全文</mt-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  props: ['liveId', 'liveInfo', 'userId'],
  data() {
    return {
      infoShow: false,
      menuShow: false,
      menuShowAll: false,
      dataForm: {
        currPage: 0,
        columnList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0,
      },
      pageIndex: 1,
      busy: false,
      handle: false,
      publishUrl: '',
      pushToken: '',
    }
  },
  mounted() {},
  methods: {
    onCopy(e) {
      this.$toast('复制成功！')
    },
    onError(e) {
      this.$toast('复制失败！')
    },

    // 控制是否开启直播
    handelUpdate() {
      //1. 获取传递过来的数据
      //下架直播不能开启关闭liveIsShelves  0上架 ,1:下架
      if (this.liveInfo.liveIsShelves === 1) {
        this.$toast('已下架直播不能开启或关闭！')
        return
      }
      this.$messagebox
        .confirm(
          `是否${this.liveInfo.liveStatus === 1 ? '关闭' : '开启'}直播`,
          '提示'
        )
        .then(() => {
          if (this.liveInfo.liveStatus === 0) {
            this.liveInfo.liveStatus = 1
          } else if (this.liveInfo.liveStatus === 1) {
            this.liveInfo.liveStatus = 2
          } else if (this.liveInfo.liveStatus === 2) {
            this.liveInfo.liveStatus = 1
          }
          this.$http({
            url: '/live/live/protalUpdate',
            method: 'put',
            data: {
              liveId: this.liveInfo.liveId,
              liveStatus: this.liveInfo.liveStatus,
              userId: this.userId,
            },
          }).then(({ data }) => {
            if (data && data.code === 0) {
              //1.2 回调提示
              this.$toast({
                message: '操作成功！!',
                type: data.code === 0 ? 'success' : 'error',
              })
              //1.3 回调列表刷新
              this.getliveInfo()
              this.$emit('reloadPage')
            } else {
              this.$toast(data.msg)
              this.getliveInfo()
            }
          })
        })
        .catch(() => {
          this.$toast('取消操作！')
        })
    },
    imageChgange(e) {
      if (e.target.nodeName == 'IMG') {
        ImagePreview({
          images: [e.target.currentSrc], //e.target.currentSrc  当前图片src
          showIndex: false,
          loop: false,
        })
      } else {
        return
      }
    },
    showInfo() {
      this.infoShow = !this.infoShow
    },
    showMenu() {
      this.menuShow = !this.menuShow
    },
    showMenuAll() {
      this.menuShowAll = !this.menuShowAll
      this.menuShow = true
    },
    // 加载更多
    loadMore() {
      this.busy = true
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getColumnList()
      }
      this.busy = false
    },
    getCatDetail(catId) {
      // this.$router.push('/catDetail/' + catId)
      // this.$router.push({
      //   path: '/catDetail',
      //   query: {
      //     catId: catId
      //   }
      // })
      const routeData = this.$router.resolve({
        path: '/catDetail',
        query: { catId: catId },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.live_infoItem {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  align-items: center;
  margin: 10px auto;
  margin-left: 20px;

  .y_color {
    color: $theme-color;
  }

  .live_infoItemC {
    width: calc(100% - 130px);
    overflow: hidden;
    text-overflow: ellipsis;
    height: 21px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .label {
    width: 60px;
  }

  button {
    // background-color: #f5a323;
    // color: #fff;
    font-size: 16px;
    border: 0;
    border-radius: 3rem;
    padding: 4px 16px;
    font-size: 12px;
  }
}

.liveInfo {
  word-break: break-all;
  font-size: 14px;
  color: #646566;
  overflow: hidden;
  height: 20px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.AllShadow {
  text-align: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  margin-top: 5px;
}

.contextShow {
  display: none;
}

.contextShowAll {
  max-height: 200px;
  box-shadow: 10px 0px 0px 0px #eee;
  overflow: hidden;
}

.menu_show {
  text-align: right;
  border-bottom: 5px solid #eee;

  // height: 100%;
  img {
    width: 24px;
    display: inline-block;
    margin-right: 2rem;
  }
}

/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}

.inforItemText {
  margin-left: 2rem;
  width: 65%;
}

/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title2;
  overflow: hidden;
  height: 45px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}

.infoItemContent {
  display: flex;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid #eee;
}

/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 100px;
  height: 75px;
  border-radius: 5px;
}

/* 图文项目的内容信息--简介 */
.infoItemDes {
  line-height: 20px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 5px 0;
  font-size: 14px;
}

.infoItemPrice {
  font-size: 14px;
  color: #999;
  padding-bottom: 5px;

  .free {
    padding: 2px 5px;
    margin-right: 1rem;
    border: 1px solid $theme-color;
    border-radius: 10px;
    color: $theme-color;
  }

  .price {
    margin-right: 1rem;
    color: $theme-color;
  }

  .catTitle {
    padding: 2rem 0;
    border-radius: 1rem;
    font-size: 20px;
    background-color: #fff;

    span:nth-child(2) {
      background-color: $theme-color;
      font-size: 14px;
      border-radius: 2rem;
      padding: 5px 8px;
      float: right;
      color: #fff;
    }
  }
}

.recom {
  margin: 1rem 0;
}

.detailDesText {
  // margin: 1.5rem 0;
  padding: 0 1.5rem;
  line-height: 25px;

  // border-bottom: 1rem solid #d4d2d2;
  .title {
    margin: 1rem 0;
    margin-bottom: 0px;
    font-weight: bold;
    font-size: 18px;
  }

  .liveLecturers {
    color: #666;
    font-size: 14px;
  }

  .desc {
    color: $font-color-desc;
    margin: 1rem 0;
    font-size: 12px;
  }

  .price {
    color: $font-color-green;
    text-align: right;
    float: right;
    font-weight: normal;

    span {
      margin-left: 5px;
      font-size: 18px;
    }
  }
}

.context {
  padding: 0 15px;
  padding-top: 10px;

  img {
    display: inline-block;
    width: 20px;
    margin-bottom: 5px;
    margin-right: 5px;
    border-radius: 5px;
  }
}

.columns {
  margin: 1rem 0;
  font-size: 18px;
  // font-weight: bold;
}

.p-title {
  margin: 1rem 0;
  // font-weight: bold;
}

.p-desc {
  color: #333;
  font-size: 14px;
  line-height: 30px;
  text-indent: 2em;
}

::v-deep img {
  width: 100%;
  display: block;
}
</style>
